import React, { useState } from 'react'
import Spinner from '../reusables/spinner';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { suspend_user, suspend_supplier } from '../../redux/actions/adminActions';

function SuspendModal({ show, handleClose, users, suspend, accessToken, customer, suspendSupplier }) {

    const [isLoading,
        setIsLoading] = useState(false)

    const handleLoading = () => {
        setIsLoading(true);

        setInterval(() => {
            setIsLoading(false)
        }, 5000)
    }

    const handleSuspend = id => {
        handleLoading();
        if(!customer){
            suspendSupplier(id, accessToken, handleClose)
        }else{
            suspend(id, accessToken, handleClose);
        }
    }


    return (
        <Modal show={ show } onHide={ handleClose } centered>
            <div className="icon--tiny isClickable closeModal" onClick={ handleClose }>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="sectionHeight--mid center">
                <div className="w-100 vAlign">
                    <h2 className="sectionText--mid">Are you sure you want to suspend { ' ' }{ users.length > 1 ? 'these' : 'this' } { ' ' } user{ users.length > 1 && 's' }?</h2>

                    <div className="pt-3 center">

                        { isLoading
                            ? <div className='center'>
                                <Spinner dark />
                            </div>
                            : <div>
                                <button className="btn__filled mx-2 hasRadius" onClick={ handleClose }>No, Cancel</button>
                                <button className="btn__transparent" onClick={ () => handleSuspend(users) }>Yes, Suspend</button>
                            </div>
                        }
                  
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    suspend: (id, token, success) => dispatch(suspend_user(id, token, success)),
    suspendSupplier:(id, token, success) => dispatch(suspend_supplier(id, token, success))
})


export default connect(mapStateToProps, mapDispatchToProps)(SuspendModal)
